module.exports = __webpack_public_path__ + "static/media/IMG_8024.5381bad5.jpg";